import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { AGENCY } from "../../i18n/dict";

export const WhatsAppFloat = () => {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 2400);
    return () => clearTimeout(t);
  }, []);

  const message = encodeURIComponent(
    "Hola Travel To Time, me gustaría información sobre un viaje."
  );

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="whatsapp-float"
          initial={{ opacity: 0, y: 30, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 right-6 z-40 flex items-end gap-3"
        >
          <AnimatePresence>
            {expanded && (
              <motion.div
                initial={{ opacity: 0, x: 30, scale: 0.9 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: 30, scale: 0.9 }}
                transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                className="max-w-[280px] bg-[#0B1416] text-[#F5F1E8] p-5 rounded-xl shadow-2xl relative"
              >
                <button
                  data-testid="whatsapp-close"
                  onClick={() => setExpanded(false)}
                  className="absolute top-2 right-2 opacity-60 hover:opacity-100"
                  aria-label="close"
                >
                  <X size={14} />
                </button>
                <div className="overline text-[#6EE3E6] mb-2">Mamadou · Travel To Time</div>
                <div className="text-sm font-light leading-relaxed">
                  ¡Hola! 👋 ¿En qué destino soñás? Respondo en pocos minutos.
                </div>
                <a
                  href={`https://wa.me/${AGENCY.whatsapp}?text=${message}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="whatsapp-cta"
                  className="tt-btn tt-btn-primary mt-4 w-full justify-center text-xs"
                >
                  Iniciar conversación
                </a>
              </motion.div>
            )}
          </AnimatePresence>

          <motion.button
            data-testid="whatsapp-button"
            onClick={() => setExpanded(!expanded)}
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.94 }}
            className="wp-pulse w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#1BB6B9] text-[#0B1416] flex items-center justify-center shadow-2xl"
            aria-label="WhatsApp"
          >
            <MessageCircle size={26} strokeWidth={1.6} />
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
